import { render, staticRenderFns } from "./UserGrowth.vue?vue&type=template&id=45f8c282&scoped=true&"
import script from "./UserGrowth.vue?vue&type=script&lang=js&"
export * from "./UserGrowth.vue?vue&type=script&lang=js&"
import style0 from "./UserGrowth.vue?vue&type=style&index=0&id=45f8c282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8c282",
  null
  
)

export default component.exports